<bootstrap-popup [id]="id" [title]="'Liste des intervenants'" [displaySubject]="displaySubject" [modalSize]="'modal-lg'" [windowCloseButton]="true">
	<form role="form" class="form-horizontal">
		<div class="form-group row selector-intervenants">
			<div class="col-sm-2"></div>
			<div class="col-sm-8" style="display: inline-flex;">
	            <button type="button" class="col-sm-3 btn btn-primary" (click)="openManageIntervenantsDialog()">
	            	Ajouter Intervenants
	            </button>
	            <select class="col-sm-7 form-control entreprise-filter" [(ngModel)]="selectedEntrepriseIntervenants">
	                <option [ngValue]="null"></option>
	                <option *ngFor="let entrepriseTLR of entreprisesExterieures" [ngValue]="entrepriseTLR">{{ entrepriseTLR.nom }}</option>
	            </select>
	            <div class="col-sm-2"></div>
            </div>
            <div class="col-sm-2"></div>
        </div>
        
		<div class="form-group row entreprises" *ngFor="let entrepriseId of entrepriseIds()">
			<div class="col-sm-12 block-ent">
				<div class="col-sm-12 checkbox-inline nom-entreprise">
					<span class="col-sm-4 nom-prenom">{{ referentielIntervenants[entrepriseId].nomEntreprise }}</span>
				</div>
				<div class="col-sm-12 checkbox-inline intervenant" *ngFor="let intervenant of referentielIntervenants[entrepriseId].intervenants; let index=index">
					<span class="col-sm-4 nom-prenom">{{ intervenant.nom }} {{ intervenant.prenom }}</span>
				</div>
			</div>
		</div>
		<div class="form-group row footer">
			<label class="col-sm-12"><span class="col-sm-12">&nbsp;</span></label>
		</div>
 		<div class="row">
			<div class="col-md-12">
				<div class="form-group text-center">
					<button type="button" class="btn btn-success" style="margin-right: 10px" (click)="onCloseRequested()">
						Fermer
					</button>
					<button type="button" class="btn btn-primary" style="margin-right: 6px" (click)="onSaveRequested()" 
						title = "Sauvegarder" [disabled]="waitingForServer">
						Sauvegarder
					</button>
				</div>
			</div>
		</div>
	</form>
</bootstrap-popup>

<signataire-dialog [id]="'intervenantsDialog'" 
	[initCommands]="editIntervenantsCommands"
	(signatairesSelected)="onIntervenantsSelected($event)"
	(closed)="onIntervenantsDialogClosed()"
	>
</signataire-dialog>
